export function isISBN (string = '') {
  if (!string || typeof string !== 'string') return false
  const pattern = /((?:[\dX]{13})|(?:[\d\-X]{17})|(?:[\dX]{10})|(?:[\d\-X]{13}))/gi
  return !!string.match(pattern)
}



// WEBPACK FOOTER //
// ./src/helpers/isbn.js